import { Injectable } from "@angular/core";
import { PublicationTemplateType } from "../../../../../brand/brand-campaign/publication-template/data/entities/publication-templates.entity";
import { SchedulePeriod } from "../../../../../brand/brand-campaign/publication-template/domain/models/publication-template";
import {
  SocialMediaBorderColor,
  SocialMediaColor,
} from "../../../../../brand/brand-campaign/publication-template/pages/publication-template-schedule/calendar-event-mappers/calendar-event.mappers";
import { assert } from "../../../../utils/assert";
import { PublicationAggregatedSummary } from "../../../domain/models/publication";
import { PublicationAggregatedCalendarViewItem } from "../../../domain/models/publication-calendar-view";
import { PublicationWithSummaryEventInput } from "../publication-with-summary-event-input";
import {
  IPublicationWithSummaryCalendarEventFactory,
  mapPublicationWithSummaryToCalendarEvents,
} from "./publication-calendar-event.mappers";

export const mapInstagramPublicationWithSummaryToCalendarEvent = (
  publication: PublicationAggregatedCalendarViewItem,
  schedule: SchedulePeriod,
  summary?: PublicationAggregatedSummary,
): PublicationWithSummaryEventInput => {
  const baseConfig = mapPublicationWithSummaryToCalendarEvents(
    publication,
    schedule,
    summary,
  );
  return {
    ...baseConfig,
    backgroundColor: SocialMediaColor.Instagram,
    borderColor: SocialMediaBorderColor.Instagram,
    extendedProps: {
      ...baseConfig.extendedProps,
      icon: "ic_instagram.svg",
    },
  };
};

@Injectable()
export class InstagramStoryWithSummaryCalendarEventFactory
  implements IPublicationWithSummaryCalendarEventFactory
{
  public create(
    publication: PublicationAggregatedCalendarViewItem,
  ): PublicationWithSummaryEventInput[] {
    return publication.recommendedSchedules.map((schedule) => {
      const eventConfig = mapInstagramPublicationWithSummaryToCalendarEvent(
        publication,
        schedule.period,
        schedule.summary,
      );

      assert(
        publication.publicationTemplateType ===
          PublicationTemplateType.InstagramStory,
      );

      return {
        ...eventConfig,
        extendedProps: {
          ...eventConfig.extendedProps,
          image: publication.thumbnailUrl,
          title: "publicationTemplate.thumbnail.instagramStory.name",
        },
      };
    });
  }
}

@Injectable()
export class InstagramSingleImageWithSummaryCalendarEventFactory
  implements IPublicationWithSummaryCalendarEventFactory
{
  public create(
    publication: PublicationAggregatedCalendarViewItem,
  ): PublicationWithSummaryEventInput[] {
    return publication.recommendedSchedules.map((schedule) => {
      const eventConfig = mapInstagramPublicationWithSummaryToCalendarEvent(
        publication,
        schedule.period,
        schedule.summary,
      );

      assert(
        publication.publicationTemplateType ===
          PublicationTemplateType.InstagramSingleImage,
      );

      return {
        ...eventConfig,
        extendedProps: {
          ...eventConfig.extendedProps,
          image: publication.thumbnailUrl,
          title: "publicationTemplate.thumbnail.instagramSingleImage.name",
        },
      };
    });
  }
}
